import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { DealCreateInterface } from '@zaoblako/shared/modules/business/dto/deal/deal.create.dto';
import { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import { CardModule } from 'primeng/card';
import { NgClass, NgIf } from '@angular/common';
import { RoomMultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/room-multi-select/room-multi-select.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { FormsModule } from '@angular/forms';
import { SumPipe } from '@zaoblako/web/shared/pipes/sum.pipe';
import { DatepickerComponent } from '@zaoblako/web/shared/dumbs/datepicker/datepicker.component';

@Component({
  selector: 'crm-deal-rent-form',
  standalone: true,
  imports: [
    CardModule,
    RoomMultiSelectComponent,
    InputNumberModule,
    JoinPipe,
    FormsModule,
    NgClass,
    NgIf,
    SumPipe,
    DatepickerComponent
  ],
  templateUrl: './deal-rent-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealRentFormComponent {
  @Input() public deal: DealCreateInterface;
  @Input() public errors: ValidationErrorInterface<DealCreateInterface>;
}
